import { Box, Typography, FormControlLabel, Checkbox, Stack } from '@mui/material';
import { MediaInfoBox } from '../Media/MediaInfoBox';

interface ShowOtherTeamsMatchClipsSectionProps {
  showOtherTeamsMatchClips: boolean;
  onShowOtherTeamsMatchClipsChange: (checked: boolean) => void;
}

export function ShowOtherTeamsMatchClipsSection({
  showOtherTeamsMatchClips,
  onShowOtherTeamsMatchClipsChange,
}: ShowOtherTeamsMatchClipsSectionProps) {
  return (
    <Stack direction="row" spacing={4} sx={{ p: 3 }}>
      <Box sx={{ flex: 1, display: 'flex', alignItems: 'center' }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={showOtherTeamsMatchClips}
              onChange={(e) => onShowOtherTeamsMatchClipsChange(e.target.checked)}
            />
          }
          label={
            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
              Möjligt att visa matchklipp från andra lags matcher
            </Typography>
          }
        />
      </Box>
      <MediaInfoBox>
        Om aktiverad kan användare se matchklipp från andra lags matcher i Play-sektionen. Detta ger
        en bredare upplevelse med fler höjdpunkter.
      </MediaInfoBox>
    </Stack>
  );
}
